module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 26.22 25"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M11.77,3.3c-.42.27-.83.52-1.22.79a5.38,5.38,0,0,0-1,.79A1.66,1.66,0,0,1,8.2,5.4c-1.88,0-3.77,0-5.65,0-.34,0-.43.1-.42.43,0,2.78,0,5.55,0,8.33s0,5.5,0,8.25c0,.37.09.47.47.47q8.27,0,16.54,0c.39,0,.49-.1.49-.48,0-2.55,0-5.09,0-7.63,0-.63,0-1.25,0-1.88,0-.11,0-.23.09-.31l2-1.55.12,0v1.39l0,6.53c0,1.34,0,2.68,0,4a1.85,1.85,0,0,1-2,2H2a1.84,1.84,0,0,1-2-2V5.25a1.83,1.83,0,0,1,2-2h9.47C11.56,3.24,11.66,3.2,11.77,3.3Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M5.36,18.67a18.75,18.75,0,0,1,.27-3.25A16.94,16.94,0,0,1,9.05,7.26a10.4,10.4,0,0,1,9.1-4c.34,0,.78.2,1,0s.06-.66.07-1c0-.74,0-1.47,0-2.29l2.53,2C23.18,3.12,24.58,4.25,26,5.36c.22.18.34.3,0,.53l-6.63,5.25a1,1,0,0,1-.18.1c0-.7,0-1.36,0-2s.13-.64-.64-.68a11.38,11.38,0,0,0-8.84,3.39,19.29,19.29,0,0,0-4.11,6.2c0,.13-.11.25-.16.38Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262cab50","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/shared.vue
// module id = d4c921db794e9692d5cc
// module chunks = 89